// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"110130fc","395":"4c5c8264","669":"43efd753","746":"12895a66"}[chunkId] + ".chunk.js";
};